<template>
  <div id="precoursesignup">
    <Printer title="30-day Pre-course Signup">
      <template v-slot:printContent>
        <p>
          Thirty days before the course, fill in the information for each registered
          participant and the course information. Submit it as directed in the
          <i>Schedule of Course Reports and Transmittals</i>.
        </p>
        <div class="row">
          <div class="ml-1 col-2">
            <b>Course Number:</b>
          </div>
          <div class="data-field col-3">
            {{ reportInfo.Header.CourseName }}
          </div>
          <div class="text-right col-2">
            <b>Course Dates:</b>
          </div>
          <div
            class="data-field col-4"
          >
            {{ reportInfo.Header.Dates }}
          </div>
        </div>
        <div class="row mb-3">
          <div class="ml-1 col-2">
            <b>Host Council:</b>
          </div>
          <div class="data-field col-3">
            {{ reportInfo.Header.HostingCouncil }}
          </div>
          <div class="text-right col-2">
            <b>Location(s):</b>
          </div>
          <div
            class="data-field col-4"
          >
            {{ reportInfo.Header.Locations }}
          </div>
        </div>

        <div class="row ml-1 mr-1">
          <div
            class="float-left r-header"
            style="width:180px;"
          >
            Name
          </div>
          <div
            class="float-left r-header"
            style="width:240px;"
          >
            Address
          </div>
          <div
            class="float-left r-header"
            style="width:200px;"
          >
            City, State, Zip
          </div>
          <div
            class="float-left r-header"
            style="width:120px;"
          >
            Cell Phone
          </div>
          <div
            class="float-left r-header"
            style="width:75px;"
          >
            Home Phone
          </div>
          <div
            class="float-left r-header"
            style="width:180px;"
          >
            Email Address
          </div>
        </div>
        <div
          class="row ml-1 mr-1"
          v-for="r in reportInfo.Details"
          :key="r.Name"
        >
          <div
            class="float-left r-cell"
            style="width:180px;"
          >
            {{ r.Name }}
          </div>
          <div
            class="float-left r-cell text-center"
            style="width:240px;"
          >
            {{ r.Address }}
          </div>
          <div
            class="float-left r-cell text-center"
            style="width:200px;"
          >
            {{ r.CityStateZip }}
          </div>
          <div
            class="float-left r-cell text-center"
            style="width:120px;"
          >
            {{ r.PhoneNumber }}
          </div>
          <div
            class="float-left r-cell"
            style="width:75px;"
          />
          <div
            class="float-left r-cell text-center"
            style="width:180px;"
          >
            {{ r.EmailAddress }}
          </div>
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import reportsApi from '@/services/api/reports.js'
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'ReportPrecourseSignup',
  components: {
    Printer
  },
  data: function () {
    return {
      reportInfo: {
        Header: {},
        Details: []
      },
      cellStyle: {
        padding: '0',
        'font-size': '5pt',
        border: '1px solid black',
        'line-height': '12px'
      },
      headerCellStyle: {
        padding: '0',
        'font-size': '5pt',
        'text-align': 'center',
        'overflow-wrap': 'break-word',
        border: '1px solid black',
        'line-height': '12px'
      }
    }
  },
  mounted: function () {
    reportsApi
      .getPreCourseSignupReport(this.$root.courseKey)
      .then(response => {
        this.reportInfo = response
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
